// @ts-nocheck
import { axiosInstance } from "helpers/axiosInstance";
import { useEffect, useState } from "react";

export const useCheckSavePrice = ({
	bestVal,
	sortArrVal,
	calculationsOld,
	childrenData,
	infantsData,
	adultsData,
	roomsData,
	id,
	setNewDate,
	newDates,
	petData,
}: any) => {
	const [newCalculations, setCalculations] = useState({});
	const [newCalLoading, setCalLoading] = useState(false);
	const [newCalError, setCalError] = useState(false);

	useEffect(() => {
		if (bestVal[sortArrVal[0]]) {
			setNewDate({
				checkin: bestVal[sortArrVal[0]].checkin,
				checkout: bestVal[sortArrVal[0]].checkout,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [bestVal[sortArrVal[0]]]);

	useEffect(() => {
		if (!newDates?.checkin || !newDates?.checkout) {
			setCalLoading(false);
			setCalError(false);
			setCalculations({});
			return;
		}
		setCalLoading(true);
		setCalError(false);

		// calculation request
		axiosInstance({
			method: "POST",
			url: "/manageBookings/recal",
			data: {
				LISTING_ID: id,
				FROM_DATE: newDates.checkin,
				TO_DATE: newDates.checkout,
				NUM_ROOMS: roomsData,
				NUM_CHILD: childrenData,
				NUM_INFANTS: infantsData,
				NUM_ADULTS: adultsData,
				NUM_PETS: petData,
				TYPE: "offers",
			},
		})
			.then((res) => {
				setCalculations(res.data.data);
				setCalLoading(false);
			})
			.catch((error) => {
				let temp = error.response.data.error;
				if (typeof error.response.data.error === "object")
					temp = Object.values(error.response.data.error)[0];
				setCalLoading(false);
				setCalError(temp);
			});
	}, [newDates, id, roomsData, adultsData, childrenData, infantsData, petData]);

	return { newCalculations };
};
